module.exports = __webpack_public_path__ + "files/4539f1a78a77ef0ef572505c1bb0545c.png";